import React, { Fragment, useState } from 'react'
import injectStyles from 'react-jss'

import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'

import CoreOutlinedButton from '../../Containers/Home/components/CoreOutlinedButton'
import ColorCircularProgress from '../ColorCircularProgress'

import { styles } from './styles'

const ButtonDropdown = ({
  classes,
  label,
  disabled = false,
  cypressId,
  options = [],
  disableStartIcon = false,
  isLoading,
}) => {
  const [isOpened, setIsOpened] = useState(false)

  return (
    <Fragment>
      <CoreOutlinedButton
        icon={
          isLoading ? (
            <ColorCircularProgress size={20} />
          ) : disableStartIcon ? null : isOpened ? (
            <RemoveIcon />
          ) : (
            <AddIcon />
          )
        }
        disabled={disabled}
        onClick={() => {
          setIsOpened(!isOpened)
        }}
        label={label}
        cypress_id={cypressId}
      />
      {isOpened ? (
        <div className={classes.optionsWrapper}>
          {options.map(option => (
            <div
              key={option.label}
              onClick={() => {
                option.onClick()
                setIsOpened(false)
              }}
            >
              <p>{option.label}</p>
              {option.description ? (
                <p className={classes.label}>{option.description}</p>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
    </Fragment>
  )
}

export default injectStyles(styles)(ButtonDropdown)
